import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ScanLine, Camera } from "lucide-react";
import { CameraScanner } from "./CameraScanner";

// Keyboard-wedge friendly scan input (scanner types code + Enter) plus a
// camera button so phones/tablets can scan without a handheld device.
export function ScanBox({ onScan, placeholder, autoFocus = true, className = "" }) {
  const [val, setVal] = useState("");
  const [camOpen, setCamOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => { if (autoFocus) ref.current?.focus(); }, [autoFocus]);
  const submit = (e) => {
    e.preventDefault();
    const code = val.trim();
    setVal("");
    if (code) onScan(code);
    ref.current?.focus();
  };
  return (
    <div className={`flex gap-2 ${className}`}>
      <form onSubmit={submit} className="relative flex-1" data-testid="scan-box">
        <ScanLine className="h-4 w-4 absolute left-3 top-2.5 text-emerald-500" />
        <Input
          ref={ref}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          placeholder={placeholder || "Scan barcode (or type + Enter)"}
          data-testid="scan-box-input"
          className="pl-9 pr-28 border-emerald-300 focus-visible:ring-emerald-500 dark:border-emerald-500/40"
        />
        <span className="absolute right-3 top-2.5 inline-flex items-center gap-1 text-[11px] font-medium text-emerald-600 pointer-events-none">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" /> Ready to scan
        </span>
      </form>
      <Button
        type="button" variant="outline" size="icon"
        onClick={() => setCamOpen(true)} title="Scan with phone camera"
        data-testid="scan-camera-btn"
        className="shrink-0 border-emerald-300 text-emerald-600 hover:bg-emerald-50 dark:border-emerald-500/40 dark:hover:bg-emerald-500/10"
      >
        <Camera className="h-4 w-4" />
      </Button>
      <CameraScanner open={camOpen} onOpenChange={setCamOpen} onDetected={(code) => onScan(code)} />
    </div>
  );
}
